export default __webpack_public_path__ + "static/media/ruby.c7bc8aaa.png";